import { useMemo } from 'react';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import type { BanditVariant } from 'src/app/pages/psf/share/shared/types';

import { getPathSuffixGenerator } from './shared/pathSuffix';
import { useGenHeadlineBanditVariantData } from './variantData';

type Result = Readonly<Partial<Record<'facebook' | 'whatsapp' | 'copy' | 'twitter', BanditVariant>>>;

export function useHeadlineBanditVariants(): Result {
	const {
		data: {
			petition: { headlineBandits },
		},
	} = usePsfSharePageData();

	const genVariantData = useGenHeadlineBanditVariantData();

	return useMemo(
		() => ({
			facebook: genVariantData(headlineBandits.facebookHeadline, getPathSuffixGenerator('facebook')),
			copy: genVariantData(headlineBandits.copylinkHeadline, getPathSuffixGenerator('copy')),
			whatsapp: genVariantData(headlineBandits.whatsappHeadline, getPathSuffixGenerator('whatsapp')),
		}),
		[headlineBandits, genVariantData],
	);
}
